module.exports = __webpack_public_path__ + "static/img/1.bae553bd.png";